var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClassify(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m19,8h-6c-2.757,0-5,2.243-5,5v6c0,2.757,2.243,5,5,5h6c2.757,0,5-2.243,5-5v-6c0-2.757-2.243-5-5-5Zm3,11c0,1.654-1.346,3-3,3h-6c-1.654,0-3-1.346-3-3v-6c0-1.654,1.346-3,3-3h6c1.654,0,3,1.346,3,3v6ZM6,15c0,.553-.448,1-1,1-2.757,0-5-2.243-5-5v-6C0,2.243,2.243,0,5,0h6c2.757,0,5,2.243,5,5,0,.553-.448,1-1,1s-1-.447-1-1c0-1.654-1.346-3-3-3h-6c-1.654,0-3,1.346-3,3v6c0,1.654,1.346,3,3,3,.552,0,1,.447,1,1Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClassify);
export default __webpack_public_path__ + "static/media/classify.3047d8d762022ca8dbf222edf2398a4f.svg";
export { ForwardRef as ReactComponent };